export default __webpack_public_path__ + "static/jawaz-41768ddf5b2e84852348fdf07f3efba2.png";